import TransactionList from "../views/TransactionList"
import TransactionDetail from "../views/TransactionDetail"

export default [
	{
		path: "/:tenantId/transactions",
		component: TransactionList,
		name: "TransactionList",
		meta: { featureId: "transactions" },
		props: true
	},
	{
		path: "/:tenantId/transactions/detail/transaction/:id",
		component: TransactionDetail,
		name: "TransactionDetail",
		meta: { featureId: "transactions" },
		props: true
	}
]
